// Mock data para e-books e produtos
export const ebooks = [
  {
    id: 1,
    title: "Treinamento de Hipertrofia Masculino",
    subtitle: "4 Semanas de Resultados Garantidos",
    description: "Programa completo de hipertrofia desenvolvido especialmente para homens de 30 a 60 anos que buscam ganho de massa muscular e definição.",
    price: 97.00,
    currency: "BRL",
    image: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1",
    target: "Homens de 30 a 60 anos",
    duration: "4 semanas",
    features: [
      "Treinos detalhados divididos em Séries A, B, C, D, E",
      "Cada série foca em um grupamento: Peito, Costas, Coxas, Glúteos, Ombros, Braços",
      "6 a 7 dias por semana de treino estruturado",
      "6 exercícios por dia com imagens demonstrativas",
      "Descrição completa: séries, repetições e carga",
      "Dieta e suplementação ajustada ao seu objetivo",
      "Receitas práticas com imagens dos pratos",
      "Imagens com descrição de como executar cada exercício"
    ],
    benefits: [
      "Ganho de massa muscular acelerado",
      "Aumento de força e resistência",
      "Melhora na composição corporal",
      "Treinos progressivos e desafiadores"
    ]
  },
  {
    id: 2,
    title: "Treinamento de Glúteos e Coxas Feminino",
    subtitle: "4 Semanas para Resultados Incríveis",
    description: "Programa especializado em hipertrofia de glúteos e coxas para mulheres de 30 a 50 anos que desejam tonificar e fortalecer o corpo inferior.",
    price: 57.00,
    currency: "BRL",
    image: "https://customer-assets.emergentagent.com/job_fitness-ebooks/artifacts/iyqwtoqh_AGACHAMENTO%20COM%20A%20BARRA.avif",
    target: "Mulheres de 30 a 50 anos",
    duration: "4 semanas",
    features: [
      "Treinos detalhados divididos em Séries A, B, C, D, E",
      "Foco especial em glúteos e coxas com exercícios eficazes",
      "6 a 7 dias por semana de treino otimizado",
      "6 exercícios por dia com imagens demonstrativas",
      "Descrição completa: séries, repetições e carga",
      "Dieta e suplementação ajustada para mulheres",
      "Receitas saudáveis com imagens dos pratos",
      "Imagens com descrição de como executar cada exercício"
    ],
    benefits: [
      "Glúteos mais firmes e tonificados",
      "Coxas definidas e fortalecidas",
      "Melhora na postura e equilíbrio",
      "Aumento da autoestima e confiança"
    ]
  },
  {
    id: 3,
    title: "Manual Completo de Treinamento de Força para Homens de 30 a 60 Anos",
    subtitle: "Guia Profissional para Personal Trainers",
    description: "Manual completo desenvolvido para personal trainers que desejam dominar as técnicas de treinamento de força específicas para homens de 30 a 60 anos.",
    price: 117.00,
    currency: "BRL",
    image: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b",
    target: "Personal Trainers (homens e mulheres)",
    duration: "Guia completo",
    features: [
      "Metodologia completa de treinamento de força",
      "Adaptações específicas para faixa etária 30-60 anos",
      "Periodização e progressão de cargas adequadas",
      "Prevenção de lesões e cuidados especiais",
      "Protocolos de avaliação física específicos",
      "Técnicas avançadas de execução de exercícios",
      "Estratégias de motivação e adesão ao treino",
      "Casos práticos e estudos de aplicação"
    ],
    benefits: [
      "Torne-se especialista em treinar homens maduros",
      "Aumente sua credibilidade profissional",
      "Conquiste e fidelize mais alunos",
      "Aplique metodologias científicas comprovadas"
    ]
  },
  {
    id: 4,
    title: "Manual Completo de Treinamento de Força para Mulheres de 30 a 50 Anos",
    subtitle: "Guia Profissional para Personal Trainers",
    description: "Manual especializado para personal trainers que querem se destacar no treinamento de força feminino, com abordagem específica para mulheres de 30 a 50 anos.",
    price: 97.00,
    currency: "BRL",
    image: "https://images.unsplash.com/photo-1648542036561-e1d66a5ae2b1",
    target: "Personal Trainers (homens e mulheres)",
    duration: "Guia completo",
    features: [
      "Metodologia específica para mulheres 30-50 anos",
      "Adaptações hormonais e metabólicas",
      "Estratégias para ganho de massa magra feminina",
      "Treinamento de força para saúde óssea",
      "Protocolos para diferentes fases da vida",
      "Técnicas de empoderamento e autoconfiança",
      "Nutrição e suplementação para mulheres",
      "Exercícios seguros e eficazes com imagens"
    ],
    benefits: [
      "Especialize-se no público feminino maduro",
      "Compreenda as particularidades do treino feminino",
      "Ajude mulheres a conquistarem seus objetivos",
      "Diferencie-se no mercado fitness"
    ]
  },
  {
    id: 5,
    title: "Plano de Resistência de 21 Dias",
    subtitle: "Foco na Adaptação e Fortalecimento em Casa",
    description: "Programa de 21 dias perfeito para mulheres que querem sair do sedentarismo, emagrecer e treinar em casa sem precisar ir à academia.",
    price: 57.00,
    currency: "BRL",
    image: "https://customer-assets.emergentagent.com/job_fitness-ebooks/artifacts/mslc9u5n_Adapta%C3%A7%C3%A3o%20ao%20Agachamento.jpg",
    target: "Mulheres iniciantes que querem treinar em casa",
    duration: "21 dias",
    features: [
      "21 dias de treinos progressivos em casa",
      "Exercícios sem equipamentos ou com itens domésticos",
      "Treinos de 20-30 minutos por dia",
      "Adaptação gradual para iniciantes",
      "Foco em emagrecimento e condicionamento",
      "Imagens detalhadas de cada exercício com séries e repetições",
      "Dicas de alimentação saudável",
      "Acompanhamento de evolução e progresso"
    ],
    benefits: [
      "Saia do sedentarismo com segurança",
      "Emagreça e ganhe condicionamento físico",
      "Treine no conforto da sua casa",
      "Desenvolva o hábito de exercícios regulares"
    ]
  },
  {
    id: 6,
    title: "Transforme Sua Vida em 21 Dias",
    subtitle: "Programa Completo de Exercícios e Nutrição",
    description: "Um programa completo de exercícios e nutrição desenvolvido especialmente para homens de 30 a 60 anos que querem deixar o sedentarismo para trás e construir uma base sólida para o futuro.",
    price: 67.00,
    currency: "BRL",
    image: "https://customer-assets.emergentagent.com/job_fitness-ebooks/artifacts/xqx39703_Homem%20antes%20e%20depois%20do%20treino%20de%20for%C3%A7a.png",
    target: "Homens de 30 a 60 anos",
    duration: "21 dias",
    features: [
      "Programa de 21 dias especialmente para iniciantes",
      "Treinos progressivos adaptados para sair do sedentarismo",
      "Plano nutricional completo e fácil de seguir",
      "Exercícios que podem ser feitos em casa ou academia",
      "Orientações sobre forma correta de execução",
      "Construção de base sólida para continuar treinando",
      "Receitas práticas e nutritivas",
      "Acompanhamento diário de evolução"
    ],
    benefits: [
      "Deixe o sedentarismo para trás definitivamente",
      "Ganhe condicionamento físico e energia",
      "Construa hábitos saudáveis duradouros",
      "Melhore sua saúde e qualidade de vida"
    ]
  }
];

// Mock de usuário logado
export const mockUser = {
  id: 1,
  name: "Usuário Teste",
  email: "usuario@teste.com",
  purchasedEbooks: []
};

// Mock de carrinho
export const mockCart = [];

// Mock de pedidos/compras
export const mockOrders = [];